import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import BaseLink from "~/components/links/BaseLink";

const StyledBaseLink = styled(BaseLink)`
    display: block;
`;

const Img = styled.img`
    display: block;
    max-width: 100%;
    @media (forced-colors: active) {
        filter: grayscale(1) brightness(10);
    }
`;

const ImageLink = ({ image, to, blockLink }) => {
    const imageProps = {
        src: image.source,
        alt: image.alt,
    };

    if (image.width) {
        imageProps["width"] = image.width;
    }
    if (image.height) {
        imageProps["height"] = image.height;
    }

    return (
        <StyledBaseLink {...{ to, blockLink }}>
            <Img {...imageProps} />
        </StyledBaseLink>
    );
};

ImageLink.propTypes = {
    image: PropTypes.shape({
        source: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
        width: PropTypes.string,
        height: PropTypes.string,
    }).isRequired,
    to: PropTypes.string.isRequired,
};

export default ImageLink;
